import { Component, OnInit } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-choose-avatar-bottomsheet',
  templateUrl: './choose-avatar-bottomsheet.component.html',
  styleUrls: ['./choose-avatar-bottomsheet.component.scss']
})
export class ChooseAvatarBottomsheetComponent implements OnInit {

  constructor(
    private bottomSheetRef: MatBottomSheetRef<ChooseAvatarBottomsheetComponent>
  ) { }
  

  ngOnInit(): void {
  }

  choose(source: string) {
    this.bottomSheetRef.dismiss(source);
  }

}
